(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/column-components/game-title.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/column-components/game-title.js');

'use strict';

const _excluded = ["title", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const GameTitle = _ref => {
  let {
      title,
      className = ''
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const baseClassName = 'game-title';
  const combinedClassName = "".concat(baseClassName, " ").concat(className).trim();
  return React.createElement("div", _extends({
    className: combinedClassName
  }, props), React.createElement("h3", {
    className: "game-title-text f-medium"
  }, title));
};
setGlobal('svs.components.marketplace.gameListNew.columnComponents.GameTitle', GameTitle);

 })(window);